module.exports = __webpack_public_path__ + "img/2012.31d9b83e.png";